import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const Brain: React.FunctionComponent<Props> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_12280_28744)'>
        <path
          d='M20.9378 7.60897C20.7628 7.09716 20.0608 7.26558 20.1056 7.80023C20.1056 8.39029 17.4373 9.53889 12.5454 9.53889C7.65356 9.53889 4.98524 8.39029 4.98524 7.80023C4.97137 7.60028 4.86574 7.40142 4.65557 7.35251C4.42619 7.29709 4.1968 7.44162 4.14239 7.67526C4.14239 7.67526 3.86074 9.48348 3.96315 10.0485L2.32971 12.8543C1.95628 13.4476 2.20488 14.3072 2.83114 14.6028L3.60251 14.994L3.41153 15.5503C3.26537 15.9415 3.35606 16.3871 3.63452 16.6783L3.68893 16.7381C3.49795 17.2238 3.65159 17.8019 4.07836 18.0888L4.08049 18.8603C4.08049 19.6731 4.68009 20.3697 5.47708 20.4794L7.46794 20.7457C8.17529 20.8424 8.70876 21.465 8.70876 22.192V23.5199C8.71623 24.085 9.55267 24.0958 9.56229 23.5199V22.192C9.56229 21.0315 8.71089 20.0393 7.57998 19.8839L5.58912 19.6177C5.2093 19.5655 4.93298 19.2472 4.93298 18.8603V17.8627C4.94685 17.6269 4.7292 17.4813 4.55743 17.3705C4.47528 17.314 4.439 17.2042 4.46887 17.1064C4.54142 16.8674 4.69719 16.5414 4.48274 16.3327C4.39846 16.211 4.12107 16.0382 4.21175 15.8502L4.53183 14.92C4.60331 14.7136 4.51156 14.4854 4.31951 14.3876L3.20887 13.8236C3.02109 13.7345 2.94534 13.4835 3.06056 13.3031L4.78362 10.344C4.8423 10.243 4.85831 10.1223 4.82843 10.0093C4.75482 9.73006 4.74415 9.33234 4.79109 8.88029C7.49891 10.9178 17.6814 10.921 20.3444 8.84769C21.0699 12.2001 19.6509 14.8841 18.4869 16.0633C18.0825 16.4969 17.8585 17.0674 17.8585 17.6694V23.521C17.8606 24.0839 18.7056 24.098 18.712 23.521V17.6694C18.712 17.2912 18.8518 16.9337 19.1025 16.6653C21.2182 14.4756 21.9425 10.9561 20.9376 7.61004L20.9378 7.60897Z'
          fill='url(#paint0_linear_12280_28744)'
          stroke='url(#paint1_linear_12280_28744)'
          strokeWidth='0.5'
        />
        <path
          d='M6.59999 6.68348C6.61493 7.21159 6.70455 7.72993 6.86886 8.22547C6.9286 8.40694 7.09504 8.52104 7.27322 8.52104C8.04779 8.42867 7.49301 7.58108 7.49621 7.08883H8.25264C8.48842 7.08883 8.6794 6.89431 8.6794 6.65416C8.69327 5.9087 9.7783 5.91087 9.79111 6.65416C9.79111 6.89431 9.98209 7.08883 10.2179 7.08883H11.4459V8.6623C11.4555 9.23172 12.2898 9.23498 12.2994 8.6623V7.08883H13.5317C13.7675 7.08883 13.9585 6.89431 13.9585 6.65416C13.9713 5.91196 15.0542 5.9087 15.067 6.65416C15.067 6.89431 15.2579 7.08883 15.4937 7.08883H16.582C16.535 7.45937 16.4454 7.82341 16.311 8.17439C16.2246 8.39825 16.3334 8.65034 16.5521 8.73728C16.7655 8.82421 17.0194 8.71771 17.1058 8.49169C17.3267 7.88641 17.4899 7.23551 17.459 6.59112C17.4494 6.44116 17.3406 6.32598 17.2168 6.2586C17.1549 6.18797 15.9546 6.22926 15.848 6.21949C15.4564 4.90027 13.5701 4.90461 13.1786 6.21949H12.2994V5.70548C13.5968 5.29471 13.5968 3.39414 12.2994 2.98337C12.3677 2.36071 11.4779 2.27052 11.4459 2.90078V3.34416C11.4448 3.57888 11.6358 3.78099 11.8737 3.77882C12.6046 3.79404 12.6024 4.89808 11.8727 4.91113C11.6369 4.91113 11.4459 5.10564 11.4459 5.34579V6.21946H10.571C10.1677 4.89916 8.30172 4.89808 7.89841 6.21946H7.46097C7.59647 3.83858 9.5265 1.88699 11.8813 1.81856C12.1171 1.81095 12.3027 1.611 12.2952 1.37084C12.2888 1.13069 12.0936 0.948139 11.8567 0.949224C8.89383 1.02964 6.47845 3.6572 6.59999 6.68348Z'
          fill='url(#paint2_linear_12280_28744)'
          stroke='url(#paint3_linear_12280_28744)'
          strokeWidth='0.5'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_12280_28744'
          x1='6.13638'
          y1='8.43597'
          x2='13.0493'
          y2='24.4406'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint1_linear_12280_28744'
          x1='6.13638'
          y1='8.43597'
          x2='13.0493'
          y2='24.4406'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint2_linear_12280_28744'
          x1='8.84602'
          y1='1.50437'
          x2='11.8919'
          y2='9.65299'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint3_linear_12280_28744'
          x1='8.84602'
          y1='1.50437'
          x2='11.8919'
          y2='9.65299'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <clipPath id='clip0_12280_28744'>
          <rect
            width='24'
            height='24'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Brain;
